import { useConfirm as useStockConfirm } from './Providers/Stock/useConfirm'
import { useConfirm as useAIGenerationConfirm } from 'components/ImagePickerModal/AIGeneration/useConfirm'
import { useConfirm as useLinkConfirm } from './Providers/Link/useConfirm'
import { useImagePickerContext } from 'components/ImagePickerModal/ImagePickerContext'

export const useConfirm = () => {
  const { provider, selectedImages } = useImagePickerContext()
  const stockConfirm = useStockConfirm()
  const aiGenerationConfirm = useAIGenerationConfirm()
  const linkConfirm = useLinkConfirm()

  // The selected media can be from unsplash or pixabay without the provider being set to 'stock'
  const isUnsplashedImage = !!selectedImages[0]?.unsplash
  const isPixabayVideo = selectedImages[0]?.url.includes('pixabay')
  const isStoryblocksVideo = selectedImages[0]?.url.includes('videoblocks')
  const isStockMedia = isUnsplashedImage || isPixabayVideo || isStoryblocksVideo

  if (isStockMedia) return stockConfirm

  switch (provider) {
    case 'stock':
      return stockConfirm
    case 'ai':
      return aiGenerationConfirm
    case 'link':
      return linkConfirm
    case 'uploads':
      return { confirm: async () => {}, isConfirming: false }
    default:
      throw new Error('provider not supported')
  }
}
